module.exports = __webpack_public_path__ + "d63d9a562fbd703fc3f3ff3f054e2292.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/img-component-bg.jpg
 ** module id = 211
 ** module chunks = 0
 **/